import { cn } from "@/lib/utils";
import { BaseIconProps } from "../Icon.model";

export default function PrevIcon({
  size = 40,
  fill,
  stroke,
  className,
  ...props
}: BaseIconProps) {
  return (
    <div className="group relative inline-block">
      {/* Default state - visible by default, hidden on hover/focus */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(
          "transition-opacity duration-200 group-hover:opacity-0 group-focus:opacity-0",
          className,
        )}
        {...props}
      >
        <g clipPath="url(#clip0_14144_15101)">
          <circle
            cx="20"
            cy="20"
            r="19"
            stroke={stroke || "white"}
            strokeWidth="2"
            fill={fill || "none"}
          />
          <g clipPath="url(#clip1_14144_15101)">
            <path
              d="M22.7105 14.71C22.3205 14.32 21.6905 14.32 21.3005 14.71L16.7105 19.3C16.3205 19.69 16.3205 20.32 16.7105 20.71L21.3005 25.3C21.6905 25.69 22.3205 25.69 22.7105 25.3C23.1005 24.91 23.1005 24.28 22.7105 23.89L18.8305 20L22.7105 16.12C23.1005 15.73 23.0905 15.09 22.7105 14.71Z"
              fill={fill || stroke || "white"}
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_14144_15101">
            <rect width="40" height="40" fill="white" />
          </clipPath>
          <clipPath id="clip1_14144_15101">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(8 8)"
            />
          </clipPath>
        </defs>
      </svg>

      {/* Hover state - hidden by default, visible on hover/focus */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(
          "absolute top-0 left-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-focus:opacity-100",
          className,
        )}
        {...props}
      >
        <g clipPath="url(#clip0_14144_15112_hover)">
          <circle
            cx="20"
            cy="20"
            r="19"
            fill={stroke || "white"}
            stroke={stroke || "white"}
            strokeWidth="2"
          />
          <g clipPath="url(#clip1_14144_15112_hover)">
            <path
              d="M22.7105 14.71C22.3205 14.32 21.6905 14.32 21.3005 14.71L16.7105 19.3C16.3205 19.69 16.3205 20.32 16.7105 20.71L21.3005 25.3C21.6905 25.69 22.3205 25.69 22.7105 25.3C23.1005 24.91 23.1005 24.28 22.7105 23.89L18.8305 20L22.7105 16.12C23.1005 15.73 23.0905 15.09 22.7105 14.71Z"
              fill={stroke === "black" ? "white" : "black"}
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_14144_15112_hover">
            <rect width="40" height="40" fill="white" />
          </clipPath>
          <clipPath id="clip1_14144_15112_hover">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(8 8)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
